import { useMemo, useState } from 'react';
import { rankingItems } from '@/mocks/home';

const filters = ['全部', '剧组风波', '资本暗线', '合约迷局', '舆论反转', '私域录音', '旧照回流'];

export default function RankingSection() {
  const [active, setActive] = useState('全部');

  const list = useMemo(() => {
    if (active === '全部') return rankingItems;
    return rankingItems.filter((item) => item.category === active);
  }, [active]);

  const maxHeat = rankingItems[0]?.heat ?? 10000;

  return (
    <section id="ranking" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="reveal flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="flex items-center gap-2 font-label text-xs tracking-[0.3em] text-accent-700">
              <i className="ri-fire-line text-[14px]" />
              HOT BOARD
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日热度榜
            </h2>
            <p className="mt-2 max-w-xl font-body text-sm text-foreground-600">
              按讨论热度与线索可信度加权排序，数字越靠前，越值得先看两眼。
            </p>
          </div>

          <div className="flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-100 px-1 py-1">
            {filters.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => setActive(item)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 font-label text-[12.5px] transition-colors ${
                  active === item
                    ? 'bg-foreground-950 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <ol className="reveal mt-10 divide-y divide-background-200 border-y border-background-200">
          {list.map((item) => (
            <li
              key={item.title}
              className="group flex cursor-pointer items-center gap-4 py-5 md:gap-6"
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-[16px] font-bold ${
                  item.rank <= 3
                    ? 'bg-accent-100 text-accent-900'
                    : 'bg-background-100 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>

              <div className="min-w-0 flex-1">
                <h3 className="truncate font-heading text-[15.5px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h3>
                <div className="mt-2 flex flex-wrap items-center gap-3">
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900">
                    {item.category}
                  </span>
                  <span className="hidden h-1.5 w-24 overflow-hidden rounded-full bg-background-200 sm:block md:w-40">
                    <span
                      className="block h-full rounded-full bg-primary-400"
                      style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                    />
                  </span>
                  <span className="font-label text-[11.5px] text-foreground-500">
                    <i className="ri-line-chart-line mr-1 text-[12px] text-accent-600" />
                    热度 {item.heat.toLocaleString()}
                  </span>
                  <span
                    className={`font-label text-[11.5px] ${
                      item.trend.includes('↓') ? 'text-secondary-600' : 'text-primary-600'
                    }`}
                  >
                    {item.trend}
                  </span>
                </div>
              </div>

              <i className="ri-arrow-right-up-line hidden text-lg text-foreground-400 transition-colors group-hover:text-primary-600 sm:block" />
            </li>
          ))}

          {list.length === 0 && (
            <li className="py-10 text-center font-body text-sm text-foreground-500">
              该分类暂无线索，换个标签看看。
            </li>
          )}
        </ol>
      </div>
    </section>
  );
}